import { Component, OnInit,Inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { AuthService } from './../../../services/auth.service';
import { Router } from  '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CmsService } from 'src/app/services/cms.service';



@Component({
  selector: 'login-modal-body',
  templateUrl: './login-modal-body.component.html',
  styleUrls: ['./login-modal-body.component.scss']
})
export class LoginModalBodyComponent implements OnInit {

  setState;
  loginForm: FormGroup;
  isSubmitted  =  false;
  faTimesCircle=faTimesCircle;
  fromModal = true;
  logo;

  constructor(private dialogRef: MatDialogRef<LoginModalBodyComponent>,
    private cmsService: CmsService,
    @Inject(MAT_DIALOG_DATA) data, private authService: AuthService, private router: Router, private formBuilder: FormBuilder,public translateService: TranslateService ) {}

  ngOnInit() {
    this.loginForm  =  this.formBuilder.group({
        email:['',Validators.compose([Validators.required,Validators.email])],
        password: ['', Validators.required],
        hiddenValidation:['']
    });


    this.cmsService.contentModel.subscribe(theme => {

      if(theme!=null){
        ;
        // this.myTheme = theme.theme;
        this.logo = theme.theme.logo;
      }
    });
}

get formControls() { return this.loginForm.controls; }

login(){
  this.loginForm.controls['hiddenValidation']?.setErrors(null);

  this.isSubmitted = true;
  if(this.loginForm.invalid){
    return;
  }

  this.authService.login(this.loginForm.value).subscribe(res =>{
    if(res){
      this.dialogRef.close();
    }
    else{
      this.loginForm.controls['email']?.setErrors({'Invalid': true});
      this.loginForm.controls['password']?.setErrors({'Invalid': true});

      return;
    }

  }, err =>{
    //Bad Request

    if(err.status==422 && err.error.isServerValidation ){
      const validationCode=err.error.code;
      //Todo: Get the msgs from a source.
      switch(validationCode){
        case 1: //Not all required parameter passed
          break;
        case 2: //User not exist
        this.loginForm.controls['email']?.setErrors({'UserNotExist': 'User Not Exist'});
          break;
        case 3://Invalid Cred
        this.loginForm.controls['email']?.setErrors({'InvalidCred': 'Invalid Credentials'});
        this.loginForm.controls['password']?.setErrors({'InvalidCred': 'Invalid Credentials'});
          break;
      }


    }
    else{//SHow soemthing went wrong msg
      this.loginForm.controls['hiddenValidation']?.setErrors({'Default': 'Something Went Wrong, Please Try Again!'});
    }

    const validationErrors = err.errors;



  });

}

close(): void {
  this.dialogRef.close();
}

ForgotPassword = false;

ForgotYourPassword(){
  this.ForgotPassword = true;
}






}
